import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Alert from "@mui/material/Alert";
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import colores from '../../shared/constants/styles';
import { Container } from '@material-ui/core';
import { maxWidth } from '@mui/system';
import ProductoSinImagen from '../../assets/images/ProductoSinImagen.png';
import { requestPreconfirmData, requestPreconfirmPresupuesto} from '../../actions/presupuesto';
import MyUserService from "../../services/myUser";
import Dolar from '../../routes/dolar';
import { useFormik } from 'formik';
import * as Yup from "yup";
import rutas from "../../routes/constants/routes";
import { useParams, useHistory } from "react-router-dom";   
import WrapperMap from './WrapperMap';
import ViewMap from './ViewMap';
import MarkerMap from './MarkerMap';
import ConfirmacionTienda from './popUpConfirmacionTienda'

//#region Estilos
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .0)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
}));
//#endregion Estilos 

const EnvioPago = (props) => {
    
    const myUser = MyUserService.getMyUser();
    const expirationTime = JSON.parse(window.localStorage.getItem("expirationtime"));
    const realExpirationTime = JSON.parse(window.localStorage.getItem("LocalSession")).shoopExpirationTime;
    const time= expirationTime ? expirationTime: 300;
    const realTime= realExpirationTime ? realExpirationTime: 300;
    const history = useHistory();
    const [tiempoRestante, setTiempoRestante] = useState(time); 
    var { presupuestoId } = useParams();

    const { presupuesto, preconfirmData } = props;
    const [detalles, setDetallePresupuesto] = useState([]);
    const routeLocation = useLocation();

    useEffect(() => {
        if (routeLocation.state?.detalles) {
            setDetallePresupuesto(routeLocation.state.detalles);
            localStorage.setItem("detalles", JSON.stringify(routeLocation.state.detalles));
        } else {
            const savedData = localStorage.getItem("detalles");
            if (savedData) {
                setDetallePresupuesto(JSON.parse(savedData));
            }
        }
    }, [routeLocation.state]);

    var tiendas = preconfirmData?.tiendas?.$values.sort();
    var transportes = preconfirmData?.listaTransportes?.$values;
    var clasificacionEnvios= preconfirmData?.clasificacionEnvios?.$values;
    var formasPago = preconfirmData?.listaFormasPago?.$values;
    // var detalles = routeLocation .state?.detalles || [];

    // var detalles = presupuesto?.presupuestoDetalles?.$values;
    const [errorMsj, setErrorMsj] = useState(false);
    
    const [administrativeArea, setAdministrativeArea] = React.useState(""); 
    const [locality, setLocality] = React.useState(""); 
    
    const [postalCode, setPostalCode] = React.useState(""); 
    const [isPostalCodeManual, setIsPostalCodeManual] = React.useState(false);
    const [postalCodeMessage, setPostalCodeMessage] = React.useState("");
        
    const [route, setRoute] = React.useState(""); 
    const [isRouteManual, setIsRouteManual] = React.useState(false);
    const [routeMessage, setRouteMessage] = React.useState("");

    const [streetNumber, setStreetNumber] = React.useState(""); 
    const [isStreetNumberManual, setIsStreetNumberManual] = React.useState(false);
    const [streetNumberMessage, setStreetNumberMessage] = React.useState("");
    
    const [openConfirmacionTienda, setOpenConfirmacionTienda] = React.useState(false);
    const handleOpenDialog  = () => {
        setOpenConfirmacionTienda(true);
    };
    const handleCloseDialog  = () => {
        setOpenConfirmacionTienda(false);
    };
    const handleConfirmDialog  = () => {
        setOpenConfirmacionTienda(false);
        handleChange('transporte');
    };
    

    useEffect(() => {
        if (props.successPreconfirm) {
            presupuesto?.id !== 0 
                && history.push(`${rutas.CARRITOCONFIRMAR}/${presupuestoId}`);
        }
    }, [props.successPreconfirm]);

    const isAvailable = (transporte) => {
        return transporte ? (transporte.clientes?.$values?.some(c => c.clienteTiendaNro === selectedDestino)) : false;
    }
    // Función para formatear el tiempo en minutos y segundos
    const formatTiempoRestante = (tiempo) => {
        const minutos = Math.floor(tiempo / 60);
        const segundos = tiempo % 60;
        return `${minutos < 10 ? '0' : ''}${minutos}:${segundos < 10 ? '0' : ''}${segundos}`;
    };

    useEffect(() => {
        const tiempoExpiracion = time;
        const temporizador = setInterval(() => {
            setTiempoRestante((prevTiempo) => {
                const nuevoTiempo = prevTiempo - 1;
                // Guarda el nuevo tiempo restante en el almacenamiento local
                localStorage.setItem('expirationtime', nuevoTiempo);
                return nuevoTiempo;
            });
        }, 1000);

        const tiempoExpiracionMillis = tiempoExpiracion * 1000;

        const redirigir = () => {
            localStorage.setItem('expirationtime', realTime);
            history.push(`${rutas.CARRITO}`); 
        };

        const expiracionTimeout = setTimeout(() => {
            redirigir();
        }, tiempoExpiracionMillis);

        // const handleBeforeUnload = (event) => {
        //     const mensaje = '¿Estás seguro de abandonar la página? Perderás los datos de la transacción.';
        //     event.returnValue = mensaje; // Estándar para la mayoría de los navegadores
        //     return mensaje; // Necesario para algunos navegadores antiguos
        // };
        // window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            clearInterval(temporizador);
            clearTimeout(expiracionTimeout);
            // window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [history]);

    // Inicialización de selecciones 
    const [selectedDestino, setSelectedDestino] = React.useState() 
    if (!!tiendas && selectedDestino === undefined) {
        setSelectedDestino(tiendas?.[0]?.tiendaNro);
    }
    const [selectedTelefono, setSelectedTelefono] = React.useState() //tiendas[0].id);
    const [selectedTransporte, setSelectedTransporte] = React.useState() 
    const [selectedClasificacionEnvio, setSelectedClasificacionEnvio] = React.useState() 
    if (!!transportes && selectedTransporte === undefined) {
        var transporteDefault = transportes?.find(t => isAvailable(t))
        transporteDefault?.id && setSelectedTransporte(transporteDefault?.id);
    }
    if (!!clasificacionEnvios && selectedClasificacionEnvio === undefined) {
        var clasificacionDefault = clasificacionEnvios?.find(t => isAvailable(t))
        clasificacionDefault?.id && setSelectedClasificacionEnvio(clasificacionDefault?.id);
    }
    const [selectedFormaPago, setSelectedFormaPago] = React.useState() 
    const [pagoDiscount, setPagoDiscount] = useState(0);
    const [descuento, setDescuento] = React.useState(0);
    const [descuentoCliente, setDescuentoCliente] = React.useState(0);
    const [mapPopUp, setMapPopUp] = useState(false);
    const [useMap, setUseMap] = useState(false);
    const [textArea, setTextArea] = useState("");
    const [clickFinal, setClickFinal] = useState(false);

    useEffect(() => {
        props.requestPreconfirmData(presupuestoId);
        return () => {
            localStorage.setItem('expirationtime', realTime);
        };        
    }, [])

    useEffect(() => {
        
    }, [selectedFormaPago, formasPago, presupuesto?.montoTotal]);

    useEffect(() => {
        const descuentosCliente = presupuesto?.descuentoCliente;
        setDescuentoCliente(descuentosCliente > 0 ? presupuesto?.montoTotalSinDto?.toFixed(2) * descuentosCliente / 100 : 0);
        const descuentosProductosCategorias = presupuesto?.presupuestoDetalles?.$values.map((descuentoDetalle) => (descuentoDetalle.descuento1 > 0 ? descuentoDetalle.montoSubtotal * descuentoDetalle.descuento1 / 100 : 0)).reduce((prev, curr) => prev + curr, 0);
        setDescuento((prev) => (prev + descuentosProductosCategorias));
    }, [props]);

    useEffect(() => {
        if (preconfirmData && preconfirmData.datosRecibe) {
            setErrorMsj(false);
            formik.setValues({
                ...formik.values,
                nombre: preconfirmData?.datosRecibe.nombre,
                apellido: preconfirmData?.datosRecibe.apellido,
                telefono: preconfirmData?.datosRecibe.telefono,
                dni: preconfirmData?.datosRecibe.nroDocumento,
            });
            const formasPagoCliente= formasPago?.find(f => !f.defaultValue || f.defaultValue === null);
            if(formasPagoCliente){
                setSelectedFormaPago(formasPagoCliente.id);
                formik.values.condicionPagoId = formasPagoCliente.id;
                setPagoDiscount(formasPagoCliente.porcentaje)
            }
        } else {
            setErrorMsj(true);
        }
    }, [props.preconfirmData]);

    const redondear = (monto) => {
        return Math.round((monto + Number.EPSILON) * 100) / 100
    }
    const calculoMontoTotalSinDcto = (items) => {
        let totalAmout = 0

        if (items !== undefined) {
            for (let i = 0; i < items.length; i++) {
                totalAmout = items[i].montoSubtotal + totalAmout
            }
        } else {
            return 0
        }
        // Esta formula es para tener dos decimales de forma precisa evitando toFixed que aveces da erroes
        return redondear(totalAmout)
    }

    const calculoMontolConDcto = (total, items, user) => {
        let descuentoPago = 0
        let totalAmoutDTo = 0

        if (items !== undefined) {
            for (let i = 0; i < items.length; i++) {
                totalAmoutDTo = items[i].montoSubtotalDto + totalAmoutDTo
            }
        } else {
            return 0
        }

        if (pagoDiscount !== 0) {
            descuentoPago = (totalAmoutDTo * pagoDiscount) / 100
        }
        // Esta formula es para tener dos decimales de forma precisa evitando toFixed que aveces da erroes
        return redondear(totalAmoutDTo - descuentoPago)
    }

    const montoTotalCarrito = calculoMontoTotalSinDcto(detalles)
    const montoTotalDescuento = calculoMontolConDcto(montoTotalCarrito, detalles, presupuesto)
    const montoDescuento = redondear(montoTotalCarrito - montoTotalDescuento)

    const handleClickMap = () => {
        setMapPopUp(!mapPopUp)
    }

    const handleCloseMap= () => {
        setMapPopUp(false)
        setSelectedObra(false);
        setUseMap(false);
    }
    //Variables para el manejo del maps de google
    const [clicks, setClicks] = React.useState([]);
    const [zoom, setZoom] = React.useState(12); // initial zoom
    const [center, setCenter] = React.useState({
        lat: -34.7982878,
        lng: -58.4735295,
    });
    const [location, setLocation] = React.useState([]);
    const [selectedObra, setSelectedObra] = React.useState(false);

    const onClick = (e) => {
        setClicks([...clicks, e.latLng]);
        setCenter(() => ({
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
        }));
    };
    const onIdle = (m) => {
    };
    const formik = useFormik({
        initialValues: {
            nombre: "",
            apellido: "",
            telefono: "",
            dni: "",
            clienteTiendaEntregaNro: selectedDestino,
            transporteId: selectedTransporte,
            clasificacionId: selectedClasificacionEnvio,
            condicionPagoId: selectedFormaPago,
            id: presupuestoId,
            contactoId: myUser?.contactoId,
            esObra: useMap,
            obraCalle: "",
            obraNro: "",
            obraCodigoPostal: "",
            obraLatitud: "",
            obraLongitud: "",
            localidad: "",
            provinciaId: "",
            TransporteDesc: textArea
        },
        validationSchema: Yup.object({
            nombre: Yup.string().required("Ingrese el nombre de la persona que recibe").matches(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/, 'Ingrese un nombre válido').trim(),
            apellido: Yup.string().required("Ingrese el apellido de la persona que recibe").matches(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/, 'Ingrese un apellido válido').trim(),
            telefono: Yup.string().matches(/^[0-9]*$/, 'Ingrese un número válido').max(15, "Ingrese un DNI válido").test("len", 'Ingrese un número de DNI', val => val?.trim().length > 0).trim(),
            dni: Yup.string().matches(/^[0-9]*$/, 'Ingrese un número válido').max(15, "Ingrese un DNI válido").test("len", 'Ingrese un número de DNI', val => val?.trim().length > 0).trim(),
            clienteTiendaEntregaNro: Yup.string().test("type", 'Debe seleccionar una tienda', value => value !== ""),
            transporteId: Yup.string().test("type", "Debe seleccionar un transporte", value => value !== ""),
            clasificacionId: Yup.string().test("type", "Debe seleccionar una clasificación de envío", value => value !== ""),
            condicionPagoId: Yup.lazy(value => {
                switch (typeof value) {
                    case 'array':
                        return Yup.array().test("type", "Debe seleccionar una una forma de pago", value => value.length > 0); // schema for object
                    case 'string':
                        return Yup.string().test("type", "Debe seleccionar una una forma de pago", value => value !== ""); // schema for string 
                    case 'null':
                        return Yup.object().test("type", "Debe seleccionar una una forma de pago", value => value.length > 0); // schema for string
                    default:
                        return Yup.mixed(); // here you can decide what is the default
                }
            }),
            esObra: Yup.bool(),
            obraCalle: Yup.string(),
            obraNro: Yup.string(),
            obraCodigoPostal: Yup.string(),
            localidad: Yup.string(),
            provinciaId: Yup.string().trim(),
            TransporteDesc: Yup.string().trim()
        }),
        onSubmit: (formData) => {
            if(selectedFormaPago != undefined){
                props.requestPreconfirmPresupuesto(formData = {
                    ...formData, condicionPagoId: formData.condicionPagoId ? formData.condicionPagoId: selectedFormaPago,
                    esObra: useMap && selectedObra,
                    provinciaId: useMap && selectedObra ? administrativeArea : "",
                    obraCalle: useMap && selectedObra ?  route: "",
                    obraNro: useMap  && selectedObra? streetNumber : "",
                    obraCodigoPostal: useMap  && selectedObra? postalCode : "",
                    localidad: useMap  && selectedObra? locality : "",
                    descuento4: descuento,
                    obraLatitud: center.lat.toString(),
                    obraLongitud: center.lng.toString(),
                    TransporteDesc: textArea
                })
            }
        }
    })
    //#region Interacciones Acordeón
    // Acordeon
    const [expanded, setExpanded] = React.useState('cliente');
    const handleChange = (panel) => {
        setExpanded(panel);
        if (formik.values.clienteTiendaEntregaNro === undefined) {
            formik.values.clienteTiendaEntregaNro = (tiendas?.[0]?.tiendaNro);
        }
        if (formik.values.transporteId === undefined) {
            var transporteDefault = transportes?.find(t => isAvailable(t));
            setSelectedTransporte(transporteDefault?.id);
            formik.values.transporteId = (transporteDefault?.id);
        }
        if (formik.values.clasificacionId === undefined) {
            var clasificacionDefault = clasificacionEnvios?.find(t => isAvailable(t));
            setSelectedClasificacionEnvio(clasificacionDefault?.id);
            formik.values.clasificacionId = (clasificacionDefault?.id);
        }
    };
    
    // Botones de selección de panel Destino

    const handleSelectDestino = (value) => (event) => {
        if (value !== 0) {
            setSelectedClasificacionEnvio(clasificacionDefault?.id);
            formik.values.clasificacionId= clasificacionDefault?.id;
            setSelectedObra(false);
            // setSelectedTransporte(transporteDefault?.id);
            // formik.values.transporteId = transporteDefault?.id;
        } 
        setSelectedDestino(value);
    };
    // Botones de selección de panel Transporte
    const handleSelectTransporte = (value) => (event) => {
        setSelectedTransporte(value);
    };
    // Botones de selección de panel para selección de envio
    const handleSelectClasificacionEnvio = (value) => (event) => {
        setSelectedClasificacionEnvio(value);
    };
    // Botones de selección de panel Forma de Pago
    const handleSelectFormaPago = (value, porcentaje) => (event) => {
        setSelectedFormaPago(value);
        setPagoDiscount(porcentaje)
        formik.values.condicionPagoId = value;

        const formaPagoDto = formasPago?.find(f => f.id === selectedFormaPago)?.porcentaje;
        const montoDescuento = presupuesto?.montoTotalSinDto?.toFixed(2) * formaPagoDto / 100;
        setDescuento(montoDescuento);
        if (!isNaN(montoDescuento)) {
            setDescuento(descuentoCliente + montoDescuento);
        }
    };

    const handleCrearObra = (event) => {
        setUseMap(true);
        setSelectedObra(true);
        setMapPopUp(false);
    }

    // const handleChangeTextArea = (event) => {
    //     setTextArea(event.target.value);
    // }

    // const handleValueMaps = (type) => {
    //     let valueMap=  location.filter(obj => {
    //         return obj.types.includes(type)
    //     });
    //     return typeof valueMap[0] != "undefined" ? type === 'administrative_area_level_1' ? valueMap[0].long_name:  valueMap[0].short_name: "";
    // }

    useEffect(() => {
        let postalcode = location.filter(obj => obj.types.includes('postal_code'));
        let extractedPostalCode = postalcode[0]?.short_name || "";
        extractedPostalCode = extractedPostalCode.replace(/\D/g, "");  
        if (!extractedPostalCode) {
            setIsPostalCodeManual(true);
            setPostalCodeMessage("No se encontró un código postal. Ingresa uno manualmente.");
        } else {
            setIsPostalCodeManual(false);
            setPostalCodeMessage("");
        }
        setPostalCode(extractedPostalCode); 

        let administrative = location.filter(obj => obj.types.includes('administrative_area_level_1'));
        let extractedAdministrative = administrative[0]?.short_name || "";
        setAdministrativeArea(extractedAdministrative);

        let locality = location.filter(obj => obj.types.includes('locality'));
        let extractedLocality = locality[0]?.short_name || "";
        setLocality(extractedLocality);

        let route = location.filter(obj => obj.types.includes('route'));
        let extractedRoute = route[0]?.short_name || "";
        setRoute(extractedRoute);
        if (!extractedRoute) {
            setIsRouteManual(true);
            setRouteMessage("No se encontró un número. Ingresa uno manualmente.");
        } else {
            setIsRouteManual(false);
            setRouteMessage("");
        }

        let streetNumber = location.filter(obj => obj.types.includes('street_number'));
        let extractedStreetNumber = streetNumber[0]?.short_name || "";
        setStreetNumber(extractedStreetNumber);
        if (!extractedStreetNumber) {
            setIsStreetNumberManual(true);
            setStreetNumberMessage("No se encontró un número. Ingresa uno manualmente.");
        } else {
            setIsStreetNumberManual(false);
            setStreetNumberMessage("");
        }
    }, [location]);

    return (
        <>
            <div style={{ overflow: "hidden", clear: "both" }}>
                <Dolar></Dolar>
                <div className='d-flex justify-content-between flex-wrap align-items-center' style={{ backgroundColor: colores.grisClaro, paddingLeft: "75px", paddingBottom: "0.600rem", paddingRight: "3rem" }}>
                    <h1 className="fw-bolder">ENVÍO Y PAGO</h1>
                    <div style={{float:'right', marginRight: '15vw'}}>
                        <h3>Tiempo restante para realizar la compra: {formatTiempoRestante(tiempoRestante)}</h3>
                    </div>
                </div>
                <Container className="py-4 px-5" component="main" maxWidth="lg">
                    <div className="row">
                        <div className='col-6'>
                            <div>
                                <form onSubmit={formik.handleSubmit} component="fieldset">
                                    {mapPopUp ?
                                        <>
                                            <div
                                                style={{
                                                    height: '100%',
                                                    width: '100%',
                                                    position: 'fixed',
                                                    left: 0,
                                                    top: 0,
                                                    zIndex: '1',
                                                    backgroundColor: 'black',
                                                    filter: 'alpha(opacity=75)',
                                                    opacity: 0.75,
                                                }}
                                            ></div>
                                            <div className="container" style={{ position: "fixed", top: '10%', left: '10%', bottom: '0', zIndex: "2", overflowY: 'auto', overflowX: 'hidden' }}>
                                                <div class="container" style={{ width: "90%" }}>
                                                    <div style={{ backgroundColor: 'white', paddingTop: "1.20rem", paddingBottom: "1.20rem", borderRadius: '15px 15px 0 0' }}>
                                                        <button onClick={handleCloseMap} className="float-end" style={{ border: "none", backgroundColor: 'white' }}>X</button>
                                                        <h5 className="text-center" style={{ fontWeight: 'lighter' }}>REGISTRÁ LA DIRECCIÓN DE LA OBRA</h5>
                                                    </div>
                                                    <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2" style={{ background: 'white', margin: 0, borderRadius: '0 0 15px 15px' }}>
                                                        <div className='col-md-4'>
                                                            <div style={{ padding: "1.25rem", margin: 0 }}>
                                                                <div className="mb-1">
                                                                    <label for="provinciaId" style={{ color: colores.grisOscuro }} className="form-label">Provincia*</label>
                                                                    <input type="text" onChange={formik.handleChange} className="form-control" id="provinciaId" name='provinciaId' value={formik.values.provinciaId || administrativeArea} disabled />
                                                                </div>
                                                                <div className="mb-1">
                                                                    <label for="localidad" style={{ color: colores.grisOscuro }} className="form-label">Localidad*</label>
                                                                    <input type="text" onChange={formik.handleChange} className="form-control" id="localidad" name='localidad' value={formik.values.localidad || locality} disabled />
                                                                </div>
                                                                <div className="mb-1">
                                                                    <label for="obraCalle" style={{ color: colores.grisOscuro }} className="form-label">Calle*</label>
                                                                    <input 
                                                                        type="text" 
                                                                        onChange={(e) => { 
                                                                            setRoute(e.target.value); 
                                                                            setRouteMessage("");
                                                                        }}  
                                                                        className="form-control" 
                                                                        id="obraCalle" 
                                                                        name='obraCalle' 
                                                                        value={formik.values.obraCalle || route} 
                                                                        disabled={!isRouteManual} 
                                                                    />
                                                                    {isRouteManual && <small style={{ color: "red" }}>{routeMessage}</small>}
                                                                </div>
                                                                <div className="mb-1">
                                                                    <label for="obraNro" style={{ color: colores.grisOscuro }} className="form-label">Nro*</label>
                                                                    <input 
                                                                        type="text" 
                                                                        onChange={(e) => { 
                                                                            setStreetNumber(e.target.value); 
                                                                            setStreetNumberMessage("");
                                                                        }}  
                                                                        className="form-control" 
                                                                        id="obraNro" 
                                                                        name='obraNro' 
                                                                        value={formik.values.obraNro || streetNumber} 
                                                                        disabled={!isStreetNumberManual} 
                                                                        />
                                                                        {isStreetNumberManual && <small style={{ color: "red" }}>{streetNumberMessage}</small>}
                                                                </div>
                                                                <div className="mb-1">
                                                                    <label for="obraCodigoPostal" style={{ color: colores.grisOscuro }} className="form-label">Código postal</label>
                                                                    <input 
                                                                        type="text" 
                                                                        onChange={(e) => { 
                                                                            setPostalCode(e.target.value.replace(/\D/g, "")); 
                                                                            setPostalCodeMessage("");
                                                                        }}  
                                                                        className="form-control" 
                                                                        id="obraCodigoPostal" 
                                                                        name='obraCodigoPostal' 
                                                                        value={formik.values.obraCodigoPostal || postalCode} 
                                                                        disabled={!isPostalCodeManual} 
                                                                        />
                                                                    {isPostalCodeManual && <small style={{ color: "red" }}>{postalCodeMessage}</small>}
                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    <button className="btn" 
                                                                        style={{ background: colores.rojo, color: "white", width: "50%" }} 
                                                                        disabled={ route == ""|| locality == ""|| administrativeArea == ""|| streetNumber == ""|| postalCode == ""}
                                                                        onClick={() => handleCrearObra()} 
                                                                    > Crear
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-8' >

                                                            <WrapperMap>
                                                                <ViewMap
                                                                    center={center}
                                                                    style={{
                                                                        height: '400px',
                                                                        width: '100%'
                                                                    }}
                                                                    onClick={onClick}
                                                                    onIdle={onIdle}
                                                                    zoom={zoom}
                                                                    location={location}
                                                                    setLocation={setLocation}
                                                                >
                                                                    <MarkerMap
                                                                        position={center}
                                                                    />
                                                                </ViewMap>
                                                            </WrapperMap>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        ""
                                    }
                                    {errorMsj && (
                                        <Alert severity="error">
                                            Lo siento, tuvimos un inconveniente. Le pedimos que se dirija al carrito nuevamente. Gracias!
                                        </Alert>
                                        )}
                                    <div>
                                        <Accordion expanded={expanded === 'cliente'}>
                                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                <Typography style={{ textTransform: 'uppercase' }}>Datos de quien recibe</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ paddingLeft: "37px", paddingRight: "37px" }}>
                                                <div className="row">
                                                    <div className="col">
                                                        <label for="nombre" className="form-label" style={{ color: "gray", fontWeight: 600, fontSize: "0.938rem" }}>Nombre</label>
                                                        <input className="form-control"
                                                            type="text"
                                                            id="nombre"
                                                            onChange={formik.handleChange}
                                                            maxLength={28}
                                                            style={{ borderColor: "black", padding: "0.625rem" }}
                                                            value={formik.values.nombre}
                                                        >
                                                        </input>
                                                        {formik.errors.nombre ? (<div className='text-danger'>{formik.errors.nombre}</div>) : null}
                                                    </div>

                                                    <div className="col">
                                                        <label for="apellido" className="form-label" style={{ color: "gray", fontWeight: 600, fontSize: "0.938rem" }}>Apellido/s</label>
                                                        <input className="form-control"
                                                            type="text"
                                                            id="apellido"
                                                            onChange={formik.handleChange}
                                                            maxLength={28}
                                                            style={{ borderColor: "black", padding: "0.625rem" }}
                                                            value={formik.values.apellido}
                                                        >
                                                        </input>
                                                        {formik.errors.apellido ? (<div className='text-danger'>{formik.errors.apellido}</div>) : null}
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <label for="telefono" className="form-label" style={{ color: "gray", fontWeight: 600, fontSize: "0.938rem" }}>Teléfono</label>
                                                        <input className="form-control"
                                                            type="text"
                                                            id="telefono"
                                                            onChange={formik.handleChange}
                                                            style={{ borderColor: "black", padding: "0.625rem" }}
                                                            maxLength={15}
                                                            value={formik.values.telefono.trimRight()}
                                                        >
                                                        </input>
                                                        {formik.errors.telefono ? (<div className='text-danger'>{formik.errors.telefono}</div>) : null}
                                                    </div>
                                                    <div className="col">
                                                        <label for="dni" className="form-label" style={{ color: "gray", fontWeight: 600, fontSize: "0.938rem" }}>Número de DNI</label>
                                                        <input className="form-control"
                                                            type="text"
                                                            id="dni"
                                                            onChange={formik.handleChange}
                                                            style={{ borderColor: "black", padding: "0.625rem" }}
                                                            maxLength={15}
                                                            value={formik.values.dni.trimRight()}
                                                        >
                                                        </input>
                                                        {formik.errors.dni ? (<div className='text-danger'>{formik.errors.dni}</div>) : null}
                                                    </div>
                                                </div>
                                                {Object.keys(formik.errors).length === 0 ? (
                                                    <div>
                                                        <button className="btn btn-danger float-end" type="button" 
                                                            onClick={() => handleChange('destino')} disabled={errorMsj}
                                                            style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem" }}>Siguiente</button>
                                                    </div>
                                                ) : null}


                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion expanded={expanded === 'destino'}>
                                            <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                                                <Typography style={{ textTransform: 'uppercase' }}>Destino</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ paddingLeft: "37px", paddingRight: "37px" }}>
                                                <div>
                                                    <FormLabel component="legend" xs={12} style={{ color: "gray", fontWeight: 600, fontSize: "0.938rem" }}>Tiendas registradas</FormLabel>
                                                    {tiendas?.map(tienda => (
                                                        <div className="row" style={{ width: maxWidth }}>
                                                            <table class="table table-hover  table-responsive table-condensed" border="0" style={{ borderColor: "white", borderBlockStartColor: "white" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <th scope="col">
                                                                            <Radio
                                                                                checked={selectedDestino === tienda.tiendaNro}
                                                                                onClick={handleSelectDestino(tienda.tiendaNro)}
                                                                                value={tienda.tiendaNro}
                                                                                name="clienteTiendaEntregaNro"
                                                                                onChange={formik.handleChange}
                                                                                inputProps={{ 'aria-label': tienda.tiendaNro }}
                                                                            />
                                                                        </th>
                                                                        <th scope="col">
                                                                            <span style={{ color: "gray", fontWeight: 600, fontSize: "0.900rem" }}>{tienda.nombreFantasia}</span><span style={{ color: "gray", fontWeight: 300, fontSize: "0.900rem" }}><br />{tienda.calle} {tienda.calleNro}, {tienda.provincia}{tienda.pais != null ? `, ${tienda.pais}` : ''} </span>
                                                                        </th>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ))}
                                                    {
                                                        useMap
                                                            ?
                                                            <div className="row" style={{ width: maxWidth }}>
                                                                <table class="table table-hover  table-responsive table-condensed" border="0" style={{ borderColor: "white", borderBlockStartColor: "white" }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th scope="col">
                                                                                <Radio
                                                                                    checked={selectedDestino === 0}
                                                                                    onClick={handleSelectDestino(0)}
                                                                                    value={0}
                                                                                    name="clienteTiendaEntregaNro"
                                                                                    onChange={formik.handleChange}
                                                                                    inputProps={{ 'aria-label': 0 }}
                                                                                />
                                                                            </th>
                                                                            <th scope="col">
                                                                                <span style={{ color: "gray", fontWeight: 600, fontSize: "0.900rem" }}>
                                                                                    Obra
                                                                                </span>
                                                                                <span style={{ color: "gray", fontWeight: 300, fontSize: "0.900rem" }}>
                                                                                    <br/>
                                                                                    { administrativeArea != "" ? administrativeArea : ""}
                                                                                    { locality != "" ? ", "+locality: ""}
                                                                                    { route != "" ? ", "+ route: ""}
                                                                                    { streetNumber != "" ? " Nro°: "+streetNumber: ""}
                                                                                    { postalCode != "" ? " CP: "+ postalCode: ""}
                                                                                </span>
                                                                                {!streetNumber ? (<div className='text-danger'>Dirección sin número, por favor verifique.</div>) : null}
                                                                            </th>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                    <div style={{ color: colores.rojo, cursor: 'pointer' }} onClick={handleClickMap}>
                                                        + ENVIAR A OBRA
                                                    </div>
                                                    <div className='float-end'>
                                                        <button className="btn btn-danger" type="button" onClick={() => handleChange('cliente')} style={{ backgroundColor: colores.grisOscuro, borderColor: colores.grisOscuro, padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem" }} >Volver</button>
                                                        <button className="btn btn-danger" type="button" onClick={handleOpenDialog} style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem", marginLeft: "1rem" }} >Siguiente</button>
                                                    </div>
                                                    {/* Popup de Confirmación de seleccion de Tienda*/}
                                                    <ConfirmacionTienda open={openConfirmacionTienda} handleClose={handleCloseDialog} handleConfirm={handleConfirmDialog} />
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion expanded={expanded === 'transporte'}>
                                            <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                                <Typography style={{ textTransform: 'uppercase' }}>clasificación de envío</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ paddingLeft: "37px", paddingRight: "37px" }}>
                                                <div>
                                                    {
                                                        clasificacionEnvios?.map( (clasificacion) => {
                                                            return (
                                                                <p>
                                                                    <table class="table table-hover  table-responsive table-condensed" border="0" style={{ borderColor: "white", borderBlockStartColor: "white" }}>
                                                                        <tbody>
                                                                            <tr>
                                                                                <th scope="col">
                                                                                    <Radio
                                                                                        checked={selectedClasificacionEnvio === clasificacion?.id}
                                                                                        onClick={handleSelectClasificacionEnvio(clasificacion?.id)}
                                                                                        value={clasificacion?.id}
                                                                                        name="clasificacionId"
                                                                                        onChange={formik.handleChange}
                                                                                        inputProps={{ 'aria-label': clasificacion?.id }}
                                                                                    />
                                                                                    <span style={{ color: "gray", fontWeight: 600, fontSize: "0.900rem" }}>{clasificacion?.descripcion}</span>
                                                                                </th>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </p>
                                                            )
                                                        })
                                                    }
                                                    {/* {
                                                        selectedTransporte?.trim() === 'EXP' ?
                                                            <div>
                                                                <div className="row d-flex justify-content-center" style={{ width: '100%' }}>
                                                                    <textarea placeholder={'Ingrese nuevo transporte'} value={textArea} onChange={handleChangeTextArea} />
                                                                </div>
                                                            </div>

                                                            :
                                                            ""
                                                    } */}

                                                    <div className='float-end'>
                                                        <button className="btn btn-danger" type="button" onClick={() => handleChange('destino')} style={{ backgroundColor: colores.grisOscuro, borderColor: colores.grisOscuro, padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem" }} >Volver</button>
                                                        { 
                                                            clasificacionEnvios?.some(t => t.id === selectedClasificacionEnvio ? true : false) 
                                                                ? (<button className="btn btn-danger" type="button" onClick={() => handleChange('pago')} style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem", marginLeft: "1rem" }} >
                                                                    Siguiente
                                                                </button>)
                                                                : (<button className="btn btn-danger" type="button" style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem", marginLeft: "1rem" }} disabled>Siguiente</button>)
                                                        }
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion expanded={expanded === 'pago'}>
                                            <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                                <Typography style={{ textTransform: 'uppercase' }}>Forma de Pago</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ paddingLeft: "37px", paddingRight: "37px" }}>
                                                {formasPago?.map(formaPago => (
                                                    <div className="row" style={{ width: maxWidth }}>
                                                        <table
                                                            class="table table-hover  table-responsive table-condensed"
                                                            border="0"
                                                            style={{ borderColor: colores.grisClaro, backgroundColor: colores.grisClaro, borderRadius: "6px" }}
                                                        >
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="col">
                                                                        <Radio
                                                                            checked={selectedFormaPago === formaPago?.id}
                                                                            value={formaPago?.id}
                                                                            name="condicionPagoId"
                                                                            onClick={handleSelectFormaPago(formaPago?.id, formaPago?.porcentaje)}
                                                                            onChange={formik.handleChange}
                                                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} />
                                                                    </th>
                                                                    <th scope="col">
                                                                        <span style={{ fontWeight: 600, fontSize: "0.900rem", textTransform: 'uppercase' }}>{formaPago?.descripcion}</span>
                                                                        <br />{formaPago?.porcentaje > 0 ? (
                                                                            <span style={{ fontWeight: 300, fontSize: "0.900rem", textTransform: 'uppercase' }}>Descuento financiero del {formaPago?.porcentaje}% adicional</span>
                                                                        ) : (
                                                                            <span style={{ fontWeight: 300, fontSize: "0.900rem", textTransform: 'uppercase' }}>Sin descuento financiero</span>
                                                                        )}

                                                                    </th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ))}
                                                <div className='float-end'>
                                                    <button className="btn btn-danger" type="button" onClick={() =>handleChange('transporte') } 
                                                        style={{ backgroundColor: colores.grisOscuro, borderColor: colores.grisOscuro, padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem" }} >
                                                            Volver
                                                    </button>
                                                        { 
                                                        selectedFormaPago === undefined ?
                                                            (<button className="btn btn-danger" type="button" style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem", marginLeft: "1rem" }} disabled>Siguiente</button>): 
                                                            (<button className="btn btn-danger" type="submit" onClick={() => { setClickFinal(true) }} 
                                                                style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem", marginLeft: "1rem" }} >
                                                                    Siguiente
                                                            </button>)
                                                    }
 
                                                    {formik.touched.nombre && formik.errors.nombre ? (<div className='text-danger'>{formik.errors.nombre}</div>) : null}
                                                    {formik.touched.apellido && formik.errors.apellido ? (<div className='text-danger'>{formik.errors.apellido}</div>) : null}
                                                    {formik.touched.telefono && formik.errors.telefono ? (<div className='text-danger'>{formik.errors.telefono}</div>) : null}
                                                    {formik.touched.dni && formik.errors.dni ? (<div className='text-danger'>{formik.errors.dni}</div>) : null}
                                                    {formik.touched.tienda && formik.errors.tienda ? (<div className='text-danger'>{formik.errors.tienda}</div>) : null}
                                                    {formik.touched.transporte && formik.errors.transporte ? (<div className='text-danger'>{formik.errors.transporte}</div>) : null}
                                                    {formik.touched.formaPago && formik.errors.formaPago ? (<div className='text-danger'>{formik.errors.formaPago}</div>) : null}
                                                    {clickFinal && selectedFormaPago === undefined ? (<div className='text-danger'>Debes seleccionar un metodo de pago</div>) : null}
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                </form>
                            </div>
                        </div>


                        <div className="col-6">
                            <div style={{ padding: "2rem" }}>
                                <div className="row" border="0"
                                    style={{
                                        borderColor: colores.grisClaro, backgroundColor: colores.grisClaro,
                                        borderRadius: "6px", padding: "2rem",
                                    }}
                                >
                                    <span style={{ fontWeight: 400, fontSize: "2rem" }} >Resumen</span>
                                    <div className="tablaproducts" style={{ height: "300px", overflow: "auto" }}>

                                        {detalles?.map(detalle => (

                                            <div class="row" style={{ margin: "2rem 0rem" }}>
                                                <div class="col" style={{ paddingInline: "0" }}>
                                                    {detalle?.producto?.images?.$values[0]
                                                        ?
                                                        (<img src={detalle?.producto?.images?.$values[0]} className="card-img-top" style={{ width: "4rem", border: "1px solid black", borderRadius: "7px" }} alt="Imagen del producto" />)
                                                        :
                                                        (<img src={ProductoSinImagen} className="card-img-top" style={{ width: "4rem", border: "1px solid black", borderRadius: "7px" }} alt="Producto sin imagen" />)
                                                    }
                                                </div>
                                                <div class="col-6">
                                                    <span style={{ color: "gray", fontWeight: 300, fontSize: "0.900rem" }}>{detalle?.producto?.descripcion}</span>
                                                    <span style={{ color: "gray", fontWeight: 600, fontSize: "0.900rem" }}><br />{detalle?.cantidadTiras} Unidades</span>
                                                </div>
                                                <div class="col" style={{ paddingInline: "0" }}>
                                                    <span style={{ color: "gray", fontWeight: 600, fontSize: "0.900rem" }}>{presupuesto?.moneda?.simbolo} {redondear(detalle?.cantidadTiras * detalle?.precioLista)}</span>
                                                </div>
                                            </div>

                                        ))}

                                    </div>

                                    <div>
                                        <table class="table table-hover  table-responsive table-condensed" >
                                            <tbody>
                                                <tr>
                                                    <th scope="col">
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >Subtotal</span>
                                                    </th>
                                                    <th scope="col" style={{ paddingInline: "0" }}>
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >{presupuesto?.moneda?.simbolo} </span>
                                                    </th>
                                                    <th scope="col" style={{ width: '400px', paddingInline: "0", textAlign: 'right' }}>
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >{montoTotalCarrito}</span>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th scope="col">
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >Descuentos</span>
                                                    </th>
                                                    <th scope="col" style={{ paddingInline: "0" }}>
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >{presupuesto?.moneda?.simbolo} </span>
                                                    </th>
                                                    <th scope="col" style={{ paddingInline: "0", textAlign: 'right' }}>
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >{montoDescuento}</span>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th scope="col">
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >TOTAL</span>
                                                    </th>
                                                    <th scope="col" style={{ paddingInline: "0" }}>
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >{presupuesto?.moneda?.simbolo}</span>
                                                    </th>
                                                    <th scope="col" style={{ paddingInline: "0", textAlign: 'right' }}>
                                                        <span style={{ fontWeight: 400, fontSize: "2rem" }} >{montoTotalDescuento}</span>
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Container>
            </div>
        </>
    );
}


export default connect
    (
        state => ({
            client: state.clientes.cliente,
            presupuesto: state.presupuestos.presupuesto,
            preconfirmData: state.presupuestos.preconfirmData,
            loading: state.presupuestos.loading,
            successPreconfirm: state.presupuestos.successPreconfirm,
        }),
        dispatch => ({
            requestPreconfirmData: (presupuestoId) => dispatch(requestPreconfirmData(presupuestoId)),
            requestPreconfirmPresupuesto: (presupuesto) => dispatch(requestPreconfirmPresupuesto(presupuesto))
        })
    )(EnvioPago);